import React from 'react';
import { useStringsContext } from '../../../../contexts/strings';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { useStaff } from '../hooks/staff';
import { StaffMemberInternal } from '../types';
import BaseDialog, { BaseDialogProps } from '../../../common/base-dialog';

interface Props extends Pick<BaseDialogProps, 'open' | 'onClose'> {
  member: StaffMemberInternal;
  teamId: string;
  season: string;
  onRemoved: () => void;
}

export default function RemoveStaffMemberModal({
  open,
  teamId,
  season,
  onClose,
  onRemoved,
  member,
}: Props) {
  const { strings } = useStringsContext();
  const { removeStaffMemberFromTeam } = useStaff();
  const [loading, setLoading] = React.useState(false);

  const onDelete = async () => {
    setLoading(true);

    try {
      await removeStaffMemberFromTeam(teamId, season, member);
      onRemoved();
      if (onClose) {
        onClose();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title={strings.staff.removeMemberFromTeam.replace('$name', member.fullName)}
    >
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          {strings.squad.cancel}
        </Button>
        <LoadingButton
          variant="contained"
          color="error"
          loading={loading}
          startIcon={<DeleteIcon />}
          onClick={onDelete}
        >
          {strings.squad.yesRemove}
        </LoadingButton>
      </DialogActions>
    </BaseDialog>
  );
}
